import { render, staticRenderFns } from "./ForgotPasswordThanks.vue?vue&type=template&id=69d0aaba&scoped=true"
import script from "./ForgotPasswordThanks.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordThanks.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordThanks.vue?vue&type=style&index=0&id=69d0aaba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d0aaba",
  null
  
)

export default component.exports